<template>
  <v-dialog v-model="dialog" fullscreen content-class="qr-code">
    <div class="qr-code__wrapper">
      <div class="qr-code__title py-5">
        <div class="w-100 d-flex justify-center">
          <router-link to="/" class="mw-145">
            <img :src="require('@/assets/nav_logo_white.png')" width="145px" />
          </router-link>
        </div>
        <v-btn
          icon
          class="absolute ma-0 color-white btn-close"
          @click="dialog = false"
        >
          <v-icon class="font-size-34">close</v-icon>
        </v-btn>
      </div>
      <div class="qr-code__content">
        <div class="qr-code__content--title">
          {{
            typeQR === qrCodeTypeList.IOS
              ? "Download iOS app"
              : "Download Android app"
          }}
        </div>
        <div class="qr-code__content--img">
          <img
            v-if="typeQR === qrCodeTypeList.IOS"
            :src="require('@/assets/qr/qrcode_ios.png')"
            width="307"
          />

          <img
            v-else
            :src="require('@/assets/qr/qrcode_android.png')"
            width="307"
          />
        </div>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import { QrCodeTypeList } from "@/helper";

export default {
  data() {
    return {
      dialog: false,
      typeQR: QrCodeTypeList.IOS,
      qrCodeTypeList: QrCodeTypeList,
    };
  },
  methods: {
    openQrCode(type) {
      this.typeQR = type;
      this.dialog = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.qr-code {
  &__wrapper {
    background: #181818;
    width: 100%;
    height: 100vh;
  }

  &__title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 90px;
  }

  &__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    &--title {
      color: #fff;
      text-align: center;
      font-feature-settings: "clig" off, "liga" off;
      font-family: Space Grotesk;
      font-size: 55px;
      font-weight: 500;
      line-height: 57.3px;
      letter-spacing: -2.55px;
      margin-bottom: 85px;
    }
    &--img {
      border-radius: 20px;
      background: #fff;
      width: 344px;
      height: 344px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}

.mw-145 {
  max-width: 145px;
}
</style>



// WEBPACK FOOTER //
// qr_code.vue?67d4a7c2